<template>
  <div class="w-full pb-16 pt-4 container" style="max-width: 30.75rem">
    <base-link
      class="mb-5 flex items-center gap-1"
      :to="$router.options.history.state.back?.toString() || '/sign-in'"
    >
      <vf-icon dir="left" name="chevron" size="md" />
      <span class="text-sm">{{ $t.backToSignIn }}</span>
    </base-link>
    <form-forgot-password />
  </div>
</template>

<script lang="ts" setup>
const { $feature, $t } = useNuxtApp()

if (!$feature.allowPasswordLogin)
  throw createError({ statusCode: 404 })

useSeoMeta({ title: $t.forgotPasswordTitle })
</script>
